<template>
  <div
    class="relative inline-flex items-center justify-center text-white"
    :style="{ width: `${size}px`, height: `${size}px` }"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    :aria-valuenow="Math.round(value)"
  >
    <svg
      class="absolute inset-0 size-full -rotate-90"
      :viewBox="`0 0 ${size} ${size}`"
      aria-hidden="true"
    >
      <circle
        class="text-black/12"
        fill="none"
        stroke="currentColor"
        :cx="size / 2"
        :cy="size / 2"
        :r="radius"
        :stroke-width="thickness"
      />
      <circle
        class="transition-[stroke-dashoffset] duration-200 ease-in-out"
        fill="none"
        stroke="currentColor"
        :cx="size / 2"
        :cy="size / 2"
        :r="radius"
        :stroke-width="thickness"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="offset"
      />
    </svg>
    <div class="relative flex items-center justify-center">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  value: { type: Number, required: true },
  size: { type: Number, required: true },
  thickness: { type: Number, required: true },
});

const radius = computed(() => (props.size - props.thickness) / 2);
const circumference = computed(() => 2 * Math.PI * radius.value);
const offset = computed(() => circumference.value * (1 - props.value / 100));
</script>
